// extracted by mini-css-extract-plugin
export default {"button":"UploadFromURLModal_button__YmZvB"};